import React from 'react';
import PropTypes from 'prop-types';
import './LoadingOverlay.css';

/**
 * LoadingOverlay Component
 * Full-screen overlay with loading spinner and message
 * Blocks user interaction while operations are in progress
 */
const LoadingOverlay = ({ message, subMessage, progress }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-overlay-content">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <h2 className="loading-message">{message}</h2>
        {subMessage && <p className="loading-submessage">{subMessage}</p>}
        {progress && (
          <>
            <div className="loading-progress">
              Processing {progress.current} of {progress.total} emails
            </div>
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: `${(progress.current / progress.total) * 100}%` }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

LoadingOverlay.propTypes = {
  message: PropTypes.string.isRequired,
  subMessage: PropTypes.string,
  progress: PropTypes.shape({
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  })
};

LoadingOverlay.defaultProps = {
  subMessage: null,
  progress: null
};

export default LoadingOverlay;
